export enum PeopleInAssetsColors {
  // Text Colors
  DarkText = '#4a4a4a',
  MediumText = '#8a8a8a',

  // Background Colors
  White = '#fff',
  LightGrayBackground = '#f5f5f5',

  // Border Colors
  LightBorder = '#c6c8cf',

  // Shadow Colors
  BoxShadow = 'rgba(0, 0, 0, 0.1)',
}

export type PeopleInAssetsColorKey = keyof typeof PeopleInAssetsColors;
